import React, { useEffect, memo, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import EStyleSheet from 'react-native-extended-stylesheet';
import { Text, TouchableOpacity, View } from 'react-native';
import NavBarComponent from '../../components/NavBar';
import { makeSelectNetworkIsConnected } from '../../selectors';
import { makeSelectNotifications, makeSelectNotificationsLoading } from '../../providers/NotificationsProvider/selectors';
import { t } from '../../services/i18n';
import styles from './styles';
import { makeSelectChecklistsLoadingSendResponse, makeSelectQueChecklists, makeSelectQuePictures } from '../../providers/ChecklistProvider/selectors';
import request from '../../utils/request';
import { sendPictureResponse, sendQuePictureSuccess, sendQueResponse } from '../../providers/ChecklistProvider/actions';
import login from '../../services/login';
import { useHistory } from '../../services/router';

function NavBar({ notifications, notificationsLoading, isConnected, queChecklists, handleSendQueResponse, handleSendPictureResponse, loading, quePictures, handleSendPictureSuccess }) {
	let hasNotification = false;
	console.log(queChecklists, "queChecklists", isConnected);
	console.log(quePictures, "quePictures", isConnected);
	const history = useHistory();


	notifications.forEach((notification) => {
		const isDeleted = notification.field8 === 'true';
		const isSeen = notification.field4 === 'true';
		const isNewUser = notification.field3 === '2';
		const isNewLocation = notification.field3 === '3';
		if (!isDeleted && !isSeen && !isNewUser && !isNewLocation) {
			hasNotification = true;
		}
	});

	const sendReq = async () => {
		if (isConnected) {
			if (queChecklists && queChecklists.length > 0) {
				queChecklists.map((queChecklist)=>{
					console.log(queChecklist, "queChecklists");
					handleSendQueResponse(queChecklist);
				})
			}
		}
	}


	const sendPictureReq = async () => {
		if (!isConnected || !quePictures || quePictures.length === 0) return;

		const batchSize = 3;

		const chunkArray = (array, size) => {
			const result = [];
			for (let i = 0; i < array.length; i += size) {
				result.push(array.slice(i, i + size));
			}
			return result;
		};

		const batches = chunkArray(quePictures, batchSize);

		for (const batch of batches) {
			try {
				await handleSendPictureResponse(batch); // send one batch
			} catch (error) {
				console.error("Failed to send image batch:", error);
				// Optionally: continue sending next batches or stop here
			}
		}
	};

	useEffect(() => {
		sendReq();
	}, [queChecklists, isConnected]);

	useEffect(() => {
		sendPictureReq();
	}, [quePictures, isConnected]);

	return (
		<>
			<NavBarComponent hasNotification={hasNotification && !notificationsLoading} />
			{!isConnected && (
				<View style={styles.connectContainer}>
					<Text style={styles.connectTitle}>{t('You do not have access to internet')}</Text>
				</View>
			)}
			{queChecklists?.length > 0 &&
				<View style={styles.queContainer}>
					<Text style={styles.queTitle}>{t(`Your ${queChecklists.length} checklists are in queue.`)}</Text>
				</View>
			}
			{quePictures?.length > 0 &&
			<TouchableOpacity onPress={()=>{
				// handleSendPictureSuccess(null);
				sendPictureReq();
			}}>

				<View style={styles.queContainer}>
					<Text style={styles.queTitle}>{t(`Your ${quePictures.length} Pictures are in queue.`)}</Text>
				</View>
			</TouchableOpacity>
			}
			{/* {loading.loading &&
				<View style={styles.queContainer}>
					<Text style={styles.queTitle}>{t(`Your checklist is being processed.`)}</Text>
				</View>
			} */}
		</>
	);
}

const mapStateToProps = createStructuredSelector({
	isConnected: makeSelectNetworkIsConnected(),
	notifications: makeSelectNotifications(),
	notificationsLoading: makeSelectNotificationsLoading(),
	queChecklists: makeSelectQueChecklists(),
	quePictures: makeSelectQuePictures(),
	loading: makeSelectChecklistsLoadingSendResponse(),
});

export function mapDisptachToProps(dispatch) {
	return {
		handleSendQueResponse: (response) => dispatch(sendQueResponse(response)),
		handleSendPictureResponse: (pictures) => dispatch(sendPictureResponse(pictures)),
		handleSendPictureSuccess: (pictures) => dispatch(sendQuePictureSuccess(pictures)),
	};
}

const withConnect = connect(
	mapStateToProps,
	mapDisptachToProps,
);

export default compose(
	withConnect,
	memo,
)(NavBar);
